import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux'

import PieTimerAnimation from 'components/common/animations/PieTimer'
import { Square } from 'components/common/genericStyles'
import { TOMATO, CUPCAKE } from 'constants/socket'
import { throttle } from 'helpers/lodash'
import useVideoContext from 'hooks/useVideoContext/useVideoContext'
import { dispatchSendSocketMessage } from 'store/dispatcher'
import { _studentsCount } from 'store/selectors/Room'
import { isMobileOrIPad } from 'utils/device'

import {
    Container,
    Button,
    Icon,
    PieTimerWrapper,
    squareCustomCss,
} from './styles'

import { BUTTON_DELAY } from '../constants'
import FoodSplotchers from '../FoodSplotchers'
import useShowInteraction from '../hooks/useShowInteraction/useShowInteraction'
import useSplotchAudio from '../hooks/useSplotchAudio/useSplotchAudio'
import useTriggerAnimation from '../hooks/useTriggerAnimation'

const ICON_BASE = '/img/tiles/greetings'

const THROTTLE_PERIOD = 2000 // ms

const FoodButton = props => {
    const isMountedRef = useRef(false)
    const { teacher, isLocal, uuid } = props
    const [showCooldown, setShowCooldown] = useState(false)
    const animate = useTriggerAnimation()
    const playSplotch = useSplotchAudio()
    const { showInteraction, resetMood, isFunMood } = useShowInteraction(uuid)

    const actionToTrigger = teacher ? CUPCAKE : TOMATO

    const studentsCount = useSelector(_studentsCount)
    const { isArtefactMode } = useVideoContext()

    const fight = throttle(() => {
        dispatchSendSocketMessage({
            action: actionToTrigger,
            reciever: props.uuid,
        })
    }, THROTTLE_PERIOD)

    const buttonProps = {
        ...props,
        onClick: () => {
            if (!isFunMood) return
            fight()
            playSplotch()
            setShowCooldown(true)
        },
        disabled: !isFunMood || showCooldown,
    }

    const containerProps = {
        ...props,
        animate,
        studentsCount,
        isArtefactMode,
        showInteraction,
        className: 'foodbutton-container',
    }

    useEffect(() => {
        isMountedRef.current = true
        const foodButtonTimeout = setTimeout(() => {
            if (isMountedRef.current) resetMood()
        }, BUTTON_DELAY)

        return () => {
            isMountedRef.current = false
            clearTimeout(foodButtonTimeout)
        }
    }, [])

    useEffect(() => {
        const vibeElement = document.getElementById(`vibe-${uuid}`)
        const vibeBtnDisp = showInteraction ? 'none' : 'flex'
        if (vibeElement) vibeElement.style.display = vibeBtnDisp
    }, [showInteraction, uuid])

    useEffect(() => {
        showCooldown &&
            setTimeout(() => setShowCooldown(() => false), THROTTLE_PERIOD)
    }, [showCooldown])

    const cooldownAnimation = showCooldown && (
        <PieTimerWrapper>
            <PieTimerAnimation />
        </PieTimerWrapper>
    )

    const iconProps = {
        src: `${ICON_BASE}/${
            isFunMood ? actionToTrigger : `${actionToTrigger}-disabled`
        }.svg`,
        isFunMood,
    }

    if (!isFunMood || isMobileOrIPad) return null

    return (
        <Container {...containerProps}>
            <FoodSplotchers {...props} />
            {!isLocal && showInteraction && (
                <Square.Area $css={squareCustomCss.area}>
                    <Square.Wrapper $css={squareCustomCss.wrapper}>
                        <Button {...buttonProps}>
                            <Icon {...iconProps} />
                            {cooldownAnimation}
                        </Button>
                    </Square.Wrapper>
                </Square.Area>
            )}
        </Container>
    )
}

export default FoodButton
